// An http(s) address, or null — an allowlist of two schemes, never a
// blocklist of javascript:/data:. For text that came from another account
// (a global collection's source and license, KPR-386; a publisher's website
// and logo, KPR-385) and becomes a link or an image on this page.
export function safeHref(value) {
	if (typeof value !== 'string') return null;
	try {
		const u = new URL(value.trim());
		return u.protocol === 'https:' || u.protocol === 'http:' ? u.href : null;
	} catch {
		return null;
	}
}
